import React from "react";
import ToggleBar from "../../commoncomponents/toggleBar";
import { Table } from "react-bootstrap";
import { utcToReportDate } from "../../../utils/dateConvert";
import { downloadCSVFile } from "../../../api/apiClient";
import Location from '../../commoncomponents/location';
import ShowIButtonName from "../../commoncomponents/showIButtonName";
import { GetLocationAddress } from "../../../utils/mapapi";

function Triplog(props) {
  const report = props.reportDetail;
  let assetName = props.assetCustomerName;
  let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
  let tempBEnabled = props.tempBEnabled;
  let tempAEnabled = props.tempAEnabled;
  let driverIDEnabled = props.driverIDEnabled;
  let assetId = props.assetId;

  const data = (
    <Table responsive striped>
      <thead>
        <tr className="nowwrapTH">
          <th>Trip Id</th>
          <th>Started</th>
          <th>Start Address</th>
          <th>End Address</th>
          <th>Completed</th>
          <th>Left depot</th>
          <th>Park Time</th>
          <th>Total Parked Time</th>
          <th>Journey Time</th>
          <th>Total Journey Time</th>
          <th>Duration</th>
          <th>Odometer Start</th>
          <th>Odometer End</th>
          <th>End Distance</th>
          <th>Fridge</th>
          {tempAEnabled && (<th>Temp A</th>)}
          {tempBEnabled && (<th>Temp B</th>)}
          {driverIDEnabled && (<th>Driver ID</th>)}
        </tr>
      </thead>
      <tbody>
        {report.map((item, index) => {
          return (
            <tr className={item.isSubTrip ? "yellowBg" : ""}>
              <td>{item.tripId}</td>
              <td>{utcToReportDate(item.started)}</td>
              <td>
                <Location
                  address={item.startAddress}
                  lat={item.startLatitude}
                  lng={item.startLongitude}
                />
              </td>
              <td>
                <Location
                  address={item.endAddress}
                  lat={item.endLatitude}
                  lng={item.endLongitude}
                />
              </td>
              <td>{utcToReportDate(item.completed)}</td>
              <td>{item.leftDepot ? "Yes" : "No"}</td>
              <td>{item.parkedTime}</td>
              <td>{item.totalParkedTime}</td>
              <td>{item.journeyTime}</td>
              <td>{item.totalJourneyTime}</td>
              <td>{item.duration}</td>
              <td>{item.odometerStart}</td>
              <td>{item.odometerEnd}</td>
              <td>{item.endDistance}</td>
              <td>{item.fridge ? "On" : "Off"}</td>
              {tempAEnabled && <td>{item.tempA}</td>}
              {tempBEnabled && <td> {item.tempB}</td>}
              {driverIDEnabled && <td>
                  {item.driverId && 
                  <ShowIButtonName
                    ibuttonId={item.ibuttonId}
                    serialno={item.serialno}
                    iButtonName={item.iButtonName}
                  />
                  }
                  </td>}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
const ReportDetailWithlocation = async () =>{
  const updatedDetails = await Promise.all(
    props.reportDetail.map(async (item) => {
      if (item.startLatitude && item.startLongitude && !item.startAddress
      ) {
         const startAddress = await GetLocationAddress(item.startLatitude, item.startLongitude);
          item.startAddress = startAddress;
      }
      if (item.endLatitude && item.endLongitude && !item.endAddress
      ) {
         const endAddress = await GetLocationAddress(item.endLatitude, item.endLongitude);
          item.endAddress = endAddress;
      }  
      return item;
    })
);
return updatedDetails;
}

  const handleDownloadExcel = async () => {
    let reportData = await ReportDetailWithlocation();
    // alert("clicked")
    downloadCSVFile(reportData, "Trips", assetName, timeZone, assetId);
  };
  return (
    <ToggleBar
      caption="Trip Log"
      download={handleDownloadExcel}
      icon="fa-building"
      color="#337ab7"
      content={data}
    />
  );
}

export default Triplog;
